import styled from "styled-components"

export const StyledOfferTextWrapper = styled.div``
